export const provinceData = [
    {
        name: 'Roma',
        residents: 42000,
        percentage: 21.0,
    },
    {
        name: 'Venezia',
        residents: 18000,
        percentage: 9.0,
    },
    {
        name: 'Milano',
        residents: 16500,
        percentage: 8.2,
    },
    {
        name: 'Palermo',
        residents: 11000,
        percentage: 5.5,
    },
    {
        name: 'Bari',
        residents: 8500,
        percentage: 4.2,
    },
    {
        name: 'Altre Province',
        residents: 105000,
        percentage: 52.1,
    },
];
